/**
 * NO03 - Fakturakopi Table Head Component
 * Table header with sortable columns
 */

import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  tableHead: {
    backgroundColor: theme.palette.grey[100],
  },
  headerCell: {
    fontWeight: 600,
    fontSize: '0.875rem',
  },
}));

interface Column {
  id: string;
  label: string;
  align?: 'left' | 'center' | 'right';
  sortable?: boolean;
}

const columns: Column[] = [
  { id: 'kundenr', label: 'Kundenummer', sortable: true },
  { id: 'kundenavn', label: 'Kundenavn', sortable: true },
  { id: 'fakturanr', label: 'Fakturanummer', sortable: true },
  { id: 'fakturaKid', label: 'Faktura KID', sortable: true },
  { id: 'ordre', label: 'Ordre', sortable: true },
  { id: 'fakturadato', label: 'Faktura dato', sortable: true },
  { id: 'fakturatotal', label: 'Fakturatotal', align: 'right', sortable: true },
  { id: 'actions', label: '', align: 'center', sortable: false },
];

export default function NO03TableHead() {
  const { classes } = useStyles();

  // TODO: Implement sorting functionality
  const handleSort = (columnId: string) => {
    console.log('Sort by:', columnId);
  };

  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.id}
            align={column.align || 'left'}
            className={classes.headerCell}
          >
            {column.sortable ? (
              <TableSortLabel onClick={() => handleSort(column.id)}>
                {column.label}
              </TableSortLabel>
            ) : (
              column.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
